import { useCallback } from 'react';

import { useAirModal } from '@air/provider-modal';

import { ContentCollectionModal } from '~/components/Modals/ContentCollectionModal/ContentCollectionModal';
import { SharePrivateBoardModal } from '~/components/SharePrivateBoardModal/SharePrivateBoardModal';
import { SharePrivateCanvasModal } from '~/components/SharePrivateCanvasModal/SharePrivateCanvasModal';
import { useSharePrivateAsset } from '~/components/SharePrivateClipModal/hooks/useSharePrivateAsset';
import { type WorkspaceAgentShareLinkMonikerSettingsTarget } from '~/components/v2/components/workspace/workspace-agent-panel/utils/toWorkspaceAgentShareLinkMonikerSubject';

/** Opens the share-settings modal that surface already uses, or navigates to in-product settings where applicable. */
export const useOpenWorkspaceAgentShareLinkSettings = () => {
  const { openShareModal } = useSharePrivateAsset({ trackLocation: 'workspace-agent' });
  const [openBoardShareModal] = useAirModal(SharePrivateBoardModal);
  const [openCanvasShareModal] = useAirModal(SharePrivateCanvasModal);
  const [openFormSettingsModal] = useAirModal(ContentCollectionModal);

  const openShareLinkSettings = useCallback(
    (settingsTarget: WorkspaceAgentShareLinkMonikerSettingsTarget) => {
      switch (settingsTarget.kind) {
        case 'asset':
          openShareModal(settingsTarget.clip);
          return;
        case 'board':
          openBoardShareModal({ boardId: settingsTarget.boardId, trackLocation: 'workspace-agent' });
          return;
        case 'canvas':
          openCanvasShareModal({ canvasId: settingsTarget.canvasId, trackLocation: 'workspace-agent' });
          return;
        case 'form':
          openFormSettingsModal({ boardId: settingsTarget.boardId, boardTitle: settingsTarget.boardTitle });
          return;
      }
    },
    [openBoardShareModal, openCanvasShareModal, openFormSettingsModal, openShareModal],
  );

  return { openShareLinkSettings };
};
